import type { IGalleryItem } from '@media-ui/gallery/src/components/Gallery/Gallery.types';
export const getItemsWithSourcePrefix = (items: IGalleryItem[]) => {
    return items.map((item) => {
        item.sourcePrefix = '@ ';
        return item;
    });
};
// export const prepareLastSlideResponse = (data: T.IGalleryAjaxData) => {
//   return {
//     items: data.galleries.items.map(
//       (gallery: T.IGalleryAjaxDataItem): IGalleryLastSlideItem => {
//         return {
//           title: gallery.title,
//           galleryId: gallery.key,
//           count: String(gallery.count),
//           picture: gallery.picture,
//           galleryProps: {
//             request: {
//               url: gallery.url,
//               prepareResponse: (
//                 response: T.ILastSlideGalleryResponse
//               ): IGalleryResponse => {
//                 return {
//                   items: response.images.map(
//                     (image): IGalleryItem => {
//                       return {
//                         ...image,
//                         ...image.picture,
//                       };
//                     }
//                   ),
//                   lastSlidesProps: [
//                     {
//                       renderType: 'GalleryLastSlide',
//                       props: {
//                         url: `${GalleryLastSlideUrl}?id=${gallery.key}`,
//                       },
//                     },
//                   ],
//                 };
//               },
//             },
//           },
//         };
//       }
//     ),
//     type: 'grid',
//   };
// };
